export default __webpack_public_path__ + "static/B0025-cd36bf2c778d28694b73de81c62aa75d.png";